import { useParams } from "react-router-dom";

export default function NotFound() {
  const { lang = "tr" } = useParams();
  return (
    <div data-testid="not-found" className="min-h-[70vh] flex items-center justify-center container-x">
      <div className="text-center">
        <p className="font-display text-8xl font-extrabold text-copper">404</p>
        <p className="text-ink text-xl mt-4">{lang === "tr" ? "Sayfa bulunamadı" : "Page not found"}</p>
        <a href={`/${lang}`} className="btn-copper mt-8">{lang === "tr" ? "Ana sayfaya dön" : "Back to home"}</a>
      </div>
    </div>
  );
}
